import {
  BillStatus,
  BillType,
  InvoiceStatus,
  InvoiceType,
} from '@rematter/frontend-lib-api-client/grpc/finance/v1/domain_pb';
import {
  PaymentMethod,
  PaymentTermCode,
} from '@rematter/frontend-lib-api-client/grpc/finance/v1/finance_pb';

export const billStatusLabels: Record<BillStatus, string> = {
  [BillStatus.UNSPECIFIED]: 'Unspecified',
  [BillStatus.PENDING]: 'Pending',
  [BillStatus.PAID]: 'Paid',
  [BillStatus.VOIDED]: 'Voided',
};

export const billTypeLabels: Record<BillType, string> = {
  [BillType.UNSPECIFIED]: 'Unspecified',
  [BillType.INBOUND]: 'Inbound',
  [BillType.OUTBOUND]: 'Outbound',
  [BillType.FREIGHT]: 'Freight',
  [BillType.ACCRUAL]: 'Accrual',
};

export const invoiceStatusLabels: Record<InvoiceStatus, string> = {
  [InvoiceStatus.UNSPECIFIED]: 'Unspecified',
  [InvoiceStatus.PROFORMA]: 'Proforma',
  [InvoiceStatus.PENDING]: 'Pending',
  [InvoiceStatus.PAID]: 'Paid',
  [InvoiceStatus.VOIDED]: 'Voided',
};

export const invoiceTypeLabels: Record<InvoiceType, string> = {
  [InvoiceType.UNSPECIFIED]: 'Unspecified',
  [InvoiceType.INBOUND]: 'Inbound',
  [InvoiceType.OUTBOUND]: 'Outbound',
  [InvoiceType.FREIGHT]: 'Freight',
  [InvoiceType.ACCRUAL]: 'Accrual',
};

export const paymentTermLabels: Record<PaymentTermCode, string> = {
  [PaymentTermCode.UNSPECIFIED]: 'Unspecified',
  [PaymentTermCode.CAD]: 'Cash Against Documents',
  [PaymentTermCode.CIA]: 'Cash In Advance',
  [PaymentTermCode.CND]: 'Cash Next Delivery',
  [PaymentTermCode.COD]: 'Cash On Delivery',
  [PaymentTermCode.EOM]: 'End of Month',
  [PaymentTermCode.LOC]: 'Letter of Credit',
  [PaymentTermCode.NET5]: 'Net 5',
  [PaymentTermCode.NET10]: 'Net 10',
  [PaymentTermCode.NET15]: 'Net 15',
  [PaymentTermCode.NET20]: 'Net 20',
  [PaymentTermCode.NET30]: 'Net 30',
  [PaymentTermCode.NET45]: 'Net 45',
  [PaymentTermCode.NET60]: 'Net 60',
  [PaymentTermCode.NET90]: 'Net 90',
  [PaymentTermCode.PIA]: 'Payment In Advance',
  [PaymentTermCode.DUE_UPON_RECEIPT]: 'Due Upon Receipt',
};

export const paymentMethodLabels: Record<PaymentMethod, string> = {
  [PaymentMethod.UNSPECIFIED]: 'Unspecified',
  [PaymentMethod.CASH]: 'Cash',
  [PaymentMethod.CHECK]: 'Check',
  [PaymentMethod.ACH]: 'ACH',
  [PaymentMethod.ATM]: 'ATM',
  [PaymentMethod.WIRE]: 'Wire',
  [PaymentMethod.WRITE_OFF]: 'Write Off',
};
